export const data =
{
    scene: 'scene_01_Tunkeuduttu',
    kysymysteksti: 'Saavut hieman hämärään eteiseen ja sytytät kattovalon katkaisijasta. Samassa iäkäs mieshenkilö saapuu kulman takaa ja hätkähtää tulijoita. Myös ohjaajasi saapuu puuskuttaen paikalle. Yrität hymyillä ja sanot reippaasti: ',
    maxp: 2,
    optiot: [
        {
            id: 1,
            teksti: 'A Päivää, kotihoidosta ollaan, lähihoitajaopiskelija (oma nimi) ja ohjaajani (ohjaajan nimi). Ovi oli varmaan unohtunut auki. Anteeksi, minun olisi pitänyt soittaa ovikelloa.Olettehan Pentti Elo?',
            valinta: 'A pahoiteltu',
            ohjaajan_palaute: 'Ehdit äsken hieman mokata, mutta et mennyt lukkoon vaan kohtasit asiakkaan ammattimaisesti. ',
            koontiteksti: 'Päätit toimia itsenäisesti etkä jäänyt odottamaan hitaasti saapuvaa ohjaajaasi. Päättelit, että ovi oli varmaankin jätetty auki juuri teitä varten. Asiakas kuitenkin säikähti teitä. Pelastit tilanteen esittäytymällä asiallisesti ja pahoittelit, ettet huomannut soittaa ovikelloa. Valintaasi liittyi seuraava ammattitaitovaatimus: <i>Opiskelija toimii vuorovaikutuksessa asiakkaan kanssa</i> ja se toteutui <i>kiitettävästi</i>, koska kriteeri <i>Kohtaa asiakkaan, omaiset ja tämän lähiverkoston välittävästi huomioiden muuttuvat tilanteet.</i> toteutui. ',
            pisteet: 2,
            arviointitiedosto: 'scene_01_BA_pahoiteltu',
            kuva: '',
            harjoiteltava: [],
            ammattitaitovaatimukset: [
                {
                    vaatimus: 'Opiskelija toimii vuorovaikutuksessa asiakkaan kanssa',
                    osaamistaso: 5,
                    relevantit_kriteerit: [
                        {
                            kriteeri: 'Kohtaa asiakkaan, omaiset ja tämän lähiverkoston välittävästi huomioiden muuttuvat tilanteet.',
                            toteutui: 'kyllä'
                        }
                    ]
                }

            ]
        },

        {
            id: 2,
            teksti: 'B Päivää, kotihoidosta ollaan, tultiin sille kotikäynnille',
            valinta: 'B ei pahoiteltu',
            ohjaajan_palaute: '(oma nimi)! Asiakas on varmasti hämillään kun törmäsit sisään yllättäen - pitäisi varmaankin pahoitella? Ja esittäytyminen kuuluu ilman muuta asiaan. ',
            koontiteksti: 'Päätit toimia itsenäisesti etkä jäänyt odottamaan hitaasti saapuvaa ohjaajaasi. Päättelit, että ovi oli varmaankin jätetty auki juuri teitä varten. Asiakas kuitenkin säikähti teitä. Tervehdit reippaasti ja kerroit että olette kotihoidosta, mutta et antanut mitään selitystä tai pahoittelua sille, että tupsahditte sisään noin vain, etkä myöskään kertonut nimeäsi. Valintaasi liittyi seuraava ammattitaitovaatimus: <i>Toimii vuorovaikutuksessa asiakkaan kanssa</i>, josta jäivät toteutumatta T1-tason kriteerit <i>Toimii ammatillisesti vuorovaikutustilanteissa osana työryhmää</i> sekä <i>Huomioi oman käyttäytymisensä vaikutukset vuorovaikutustilanteissa</i>. Näin ollen toimintasi oli tässä <b>hylätyn</b> tasoista. ',
            pisteet: 0,
            arviointitiedosto: 'scene_01_BB_eiPahoiteltu',
            kuva: '',
            harjoiteltava: ['vuorovaikutustaidot, asiakkaan kohtaaminen erilaisissa tilanteissa'],
            ammattitaitovaatimukset: [
                {
                    vaatimus: 'Toimii vuorovaikutuksessa asiakkaan kanssa',
                    osaamistaso: 0,
                    relevantit_kriteerit: [
                        {
                            kriteeri: 'Toimii ammatillisesti vuorovaikutustilanteissa osana työryhmää',
                            toteutui: 'ei'
                        },
                        {
                            kriteeri: 'Huomioi oman käyttäytymisensä vaikutukset vuorovaikutustilanteissa',
                            toteutui: 'ei'
                        }
                    ]
                }]

        }

    ],


};



